import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import categoriaAdminService from '../../services/categoriaAdminService';
import { FaPlus, FaEdit, FaTags } from 'react-icons/fa';

const FORM_INICIAL = {
  nombre: '', tipo: 'gasto', color: '#1E40AF', activo: true,
};

export default function CategoriasPage() {
  const [categorias,   setCategorias]   = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando,     setEditando]     = useState(null);
  const [form,         setForm]         = useState(FORM_INICIAL);

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const data = await categoriaAdminService.listar();
      setCategorias(data);
    } finally {
      setCargando(false);
    }
  };

  const abrirModal = (categoria = null) => {
    setEditando(categoria);
    setForm(categoria ? {
      nombre: categoria.nombre,
      tipo:   categoria.tipo,
      color:  categoria.color,
      activo: categoria.activo,
    } : FORM_INICIAL);
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
    setEditando(null);
    setForm(FORM_INICIAL);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      editando
        ? await categoriaAdminService.actualizar(editando.id, form)
        : await categoriaAdminService.crear(form);
      cerrarModal();
      cargarDatos();
    } catch (err) {
      console.error('Error al guardar categoría:', err);
    }
  };

  const handleDesactivar = async (id) => {
    if (!window.confirm('¿Desactivar esta categoría?')) return;
    await categoriaAdminService.desactivar(id);
    cargarDatos();
  };

  return (
    <Layout>

      {/* Encabezado */}
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Categorías</h4>
          <p>Gestion de categorías personalizadas</p>
        </div>
        <button className="btn btn-danger" onClick={() => abrirModal()}>
          <FaPlus className="me-2" /> Nueva Categoría
        </button>
      </div>

      {/* Tabla */}
      <div className="card card-custom">
        <div className="card-body">
          {cargando ? (
            <div className="text-center py-4">
              <div className="spinner-custom mx-auto" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr>
                    <th>Color</th>
                    <th>Nombre</th>
                    <th>Tipo</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {categorias.length > 0 ? (
                    categorias.map((c) => (
                      <tr key={c.id}>
                        <td>
                          <div
                            style={{
                              width:        '24px',
                              height:       '24px',
                              borderRadius: '50%',
                              background:   c.color,
                              border:       '2px solid #dee2e6',
                            }}
                          />
                        </td>
                        <td className="fw-bold">{c.nombre}</td>
                        <td>
                          <span className={`badge ${
                            c.tipo === 'ingreso' ? 'bg-success' :
                            c.tipo === 'gasto'   ? 'bg-danger'  : 'bg-primary'
                          }`}>
                            {c.tipo}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${
                            c.activo ? 'badge-activo' : 'badge-anulado'
                          }`}>
                            {c.activo ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={() => abrirModal(c)}
                          >
                            <FaEdit />
                          </button>
                          {c.activo && (
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDesactivar(c.id)}
                            >
                              Desactivar
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-4">
                        <FaTags size={32} className="mb-2 d-block mx-auto" />
                        Sin categorías registradas
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {mostrarModal && (
        <div className="modal-overlay">
          <div className="modal-custom">
            <div className="modal-header-custom">
              <h5>{editando ? 'Editar Categoría' : 'Nueva Categoría'}</h5>
              <button className="btn-close-custom" onClick={cerrarModal}>×</button>
            </div>
            <div className="modal-body-custom">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">

                  <div className="col-md-8">
                    <label className="form-label fw-bold">Nombre *</label>
                    <input
                      name="nombre"
                      className="form-control"
                      value={form.nombre}
                      onChange={handleChange}
                      required
                      maxLength={100}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-bold">Color</label>
                    <input
                      name="color"
                      type="color"
                      className="form-control form-control-color w-100"
                      value={form.color}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-bold">Tipo *</label>
                    <select
                      name="tipo"
                      className="form-select"
                      value={form.tipo}
                      onChange={handleChange}
                      required
                    >
                      <option value="ingreso">Ingreso</option>
                      <option value="gasto">Gasto</option>
                      <option value="ambos">Ambos</option>
                    </select>
                  </div>

                  {editando && (
                    <div className="col-md-6 d-flex align-items-end">
                      <div className="form-check">
                        <input
                          name="activo"
                          type="checkbox"
                          className="form-check-input"
                          checked={form.activo}
                          onChange={handleChange}
                          id="activoCheck"
                        />
                        <label className="form-check-label fw-bold" htmlFor="activoCheck">
                          Activo
                        </label>
                      </div>
                    </div>
                  )}

                </div>

                <div className="d-flex gap-2 justify-content-end mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={cerrarModal}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-danger">
                    {editando ? 'Actualizar' : 'Guardar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

    </Layout>
  );
}